export enum StatsCounter {
  PARTICIPANT_PUBLISHER_CONNECTION_FAILED = 'participant_publisher_connection_failed',
  PARTICIPANT_SUBSCRIBER_CONNECTION_FAILED = 'participant_subscriber_connection_failed',
  MIX_SUBSCRIBER_CONNECTION_FAILED = 'mix_subscriber_connection_failed',
  LIVESTREAM_SUBSCRIBER_CONNECTION_FAILED = 'livestream_subscriber_connection_failed',
  SCREENSHARE_SUBSCRIBER_CONNECTION_FAILED = 'screenshare_subscriber_connection_failed',
  SCREENSHARE_PUBLISHER_CONNECTION_FAILED = 'screenshare_publisher_connection_failed',
  MIRROR_SUBSCRIBER_CONNECTION_FAILED = 'mirror_subscriber_connection_failed',
  LIVE_STREAM_SUBSCRIBER_CONNECTION_FAILED = 'live_stream_subscriber_connection_failed',
}

export enum PublisherType {
  PARTICIPANT = 'PARTICIPANT',
  SCREEN_SHARE = 'SCREEN_SHARE',
}
